import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/** Compose Tailwind classes, letting a later conflicting utility win (shadcn/ui pattern). */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map